import { render, staticRenderFns } from "./IllustrationBox.vue?vue&type=template&id=541bbc22&lang=pug&"
import script from "./IllustrationBox.vue?vue&type=script&lang=ts&"
export * from "./IllustrationBox.vue?vue&type=script&lang=ts&"
import style0 from "./IllustrationBox.vue?vue&type=style&index=0&id=541bbc22&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports